import React from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { injectIntl, intlShape } from 'react-intl';
import ChangeCourseConfirmation from './confirmation';
import ChangeCourseConfirmationWithActivities from './activity-confirmation';
import ChangeCourseForm from './form';
import {
    getProductCourses,
    getSchoolCourses,
    getUPFCourses,
    getNewCourses,
    clearProductCourses
} from '../../containers/class-roll/actions';
import {
    backToChangeCourse,
    changeCourse,
    changeCourseCarryOver,
    closeChangeCourse,
    handleCountryDropdownChanges } from '../../containers/edit-class/actions';
import { getCourseCountries } from '../../containers/school-roll/actions';
import { filterYearGroups } from '../../helpers/utils';
import { DEFAULT_NEW_COURSE_ID, DEFAULT_UPF_COURSE_ID } from '../../constants';
import messages from './messages';

const ChangeCourse = (props) => {
    const {
        isChangingCourseSuccess,
        changeCourseActivitiesIsActive,
        changeCourseIsActive,
        upfCourses,
        newCourses,
        intl
    } = props;
    let updatedUPFCourses = upfCourses.map(upfCourse => ({
        ...upfCourse,
        key: parseInt(upfCourse.id, 10),
        value: upfCourse.name
    }));

    updatedUPFCourses = [{
        key: DEFAULT_UPF_COURSE_ID,
        value: intl.formatMessage(messages.none),
        name: intl.formatMessage(messages.none)
    },
    ...updatedUPFCourses];

    let updatedNewCourses = newCourses.map(newCourse => ({
        ...newCourse,
        key: newCourse.id,
        value: newCourse.name
    }));

    updatedNewCourses = [{
        key: DEFAULT_NEW_COURSE_ID,
        value: intl.formatMessage(messages.none),
        name: intl.formatMessage(messages.none)
    },
    ...updatedNewCourses];

    return (<div>
        <ChangeCourseForm
            isActive={changeCourseIsActive}
            {...props}
            newCourses={updatedNewCourses}
            upfCourses={updatedUPFCourses} />
        <ChangeCourseConfirmation isActive={isChangingCourseSuccess} {...props} />
        <ChangeCourseConfirmationWithActivities isActive={changeCourseActivitiesIsActive} {...props} />
    </div>);
};

ChangeCourse.propTypes = {
    changeCourseActivitiesIsActive: PropTypes.bool,
    changeCourseIsActive: PropTypes.bool,
    countries: PropTypes.arrayOf(PropTypes.object),
    intl: intlShape.isRequired,
    isChangingCourseSuccess: PropTypes.bool,
    selectedProduct: PropTypes.object,
    getUPFCourses: PropTypes.func,
    upfCourses: PropTypes.array,
    newCourses: PropTypes.array,
    clearProductCourses: PropTypes.func
};

ChangeCourse.defaultProps = {
    upfCourses: []
};

function mapStateToProps(state = {}) {
    return {
        assignedCourseId: state.editClass.assignedCourseId,
        assignedUpfCourseId: state.editClass.assignedUpfCourseId,
        assignedNewCourseId: state.editClass.assignedNewCourseId,
        changeCourse: state.classRoll.changeCourse,
        changeCourseClassroomId: state.editClass.changeCourseClassroomId,
        changeCourseGroupId: state.editClass.changeCourseGroupId,
        changeCourseActivitiesIsActive: state.editClass.changeCourseActivitiesIsActive,
        changeCourseAssignedTasks: state.editClass.changeCourseAssignedTasks,
        changeCourseSubmittedFields: state.editClass.changeCourseSubmittedFields,
        changeCourseTaskActionType: state.editClass.changeCourseTaskActionType,
        changeCourseIsActive: state.editClass.changeCourseIsActive,
        classroomDetail: state.editClass.classroomDetail,
        countries: state.schoolRoll.countries.filtered,
        courseFetching: state.classRoll.isProductCoursesFetching || state.classRoll.isSchoolCoursesFetching,
        isChangingCourseCarryOverInProgress: state.editClass.isChangingCourseCarryOverInProgress,
        isChangingCourseCarryOverSuccess: state.editClass.isChangingCourseCarryOverSuccess,
        isChangingCourseInProgress: state.editClass.isChangingCourseInProgress,
        isChangingCourseSuccess: state.editClass.isChangingCourseSuccess,
        selectedGroup: state.editClass.selectedGroup,
        selectedProduct: state.product,
        yearGroups: filterYearGroups(state.editClass.countryYearGroups),
        yearGroupFetching: state.editClass.fetchingYeargroups,
        courses: state.classRoll.productCourses,
        upfCourses: state.classRoll.upfCourses,
        newCourses: state.classRoll.newCourses
    };
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        backToChangeCourse,
        closeChangeCourse,
        getCourseCountries,
        getProductCourses,
        getSchoolCourses,
        changeCourse,
        changeCourseCarryOver,
        handleCountryDropdownChanges,
        getUPFCourses,
        getNewCourses,
        clearProductCourses
    }, dispatch);
}

const ChangeCourseIntl = injectIntl(ChangeCourse);

const ConnectedChangeCourse = connect(mapStateToProps, mapDispatchToProps)(ChangeCourseIntl);

export default ConnectedChangeCourse;



// WEBPACK FOOTER //
// ./app/components/change-course/index.js